<script>
    import { format } from "svelte-i18n";
    import { goto, params } from "@roxi/routify";

    $goto;
    $params;

    const redirect = (path, filter) => $goto(path, filter);

    let {
        title = "",
        redirectTo = "vulnerability",
        totals = {
            critical: 0,
            high: 0,
            medium: 0,
            low: 0,
        },
    } = $props();

    let filter = null;

    const handleCurrentFilter = (severity) => {
        let currentFilter = { ...$params };
        if (currentFilter.level__in) delete currentFilter.level__in;
        if (currentFilter.vulnerability__level__in)
            delete currentFilter.vulnerability__level__in;
        if (redirectTo == "vulnerability") {
            currentFilter.level__in = severity;
        }
        if (redirectTo == "finding") {
            currentFilter.vulnerability__level__in = severity;
        }
        // console.log(currentFilter, "current")
        // let newParams = new URLSearchParams(currentFilter);
        // console.log(newParams, "new params")
        // const unencoded = Array.from(newParams)
        //     .map(([key, value]) => `${key}=${value}`)
        //     .join("&");
        // Result: "q=search term&id=123"

        return redirect(`/${redirectTo}`, currentFilter);
    };
</script>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <div class="card-title">
                    {title}
                </div>
            </div>
            <div class="card-body d-flex">
                {#each Object.entries(totals) as [name, total]}
                    <div class="col-3">
                        <!--<div class="card card-{name}" class:filter={filter == name} on:click={()=>dispatchFilterEvent(name)}>-->
                        <div
                            class="card card-{name} card-hover me-3"
                            class:filter={filter == name}
                            onclick={() => handleCurrentFilter(name)}
                        >
                            <div
                                class="card-header card-header-slim text-dashboard-box"
                                style="text-align: center; font-size: 1.6em"
                            >
                                {$format(`vulnerability.severity.${name}`)
                                    .charAt(0)
                                    .toUpperCase() +
                                    $format(
                                        `vulnerability.severity.${name}`,
                                    ).slice(1)}
                            </div>
                            <div
                                class="card-body text-dashboard-box pb-3 pt-3"
                                style="text-align: center"
                            >
                                <div
                                    class={"t-severity-totals-" +
                                        name +
                                        "-value"}
                                >
                                    {total}
                                </div>
                            </div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
</div>

<style>
    /* box */
    .cvss-box {
        text-align: center;
        font-size: 1.8em;
        color: white;
        height: 4em;
    }

    .card-hover {
        cursor: pointer;
    }

    .card-hover:hover {
        box-shadow: inset 0px 0px 5px 0px #ccc;
    }

    .small-box.critical {
        background: #9046844d linear-gradient(180deg, #904684b3, #904684e6)
            repeat-x !important;
    }

    .small-box.high {
        background: #a021284d linear-gradient(180deg, #a02128b3, #a02128e6)
            repeat-x !important;
    }

    .small-box.medium {
        background: #d4652f4d linear-gradient(180deg, #d4652fb3, #d4652fe6)
            repeat-x !important;
    }

    .small-box.low {
        background: #f7ba0b80 linear-gradient(180deg, #f7ba0bb3, #f7ba0be6)
            repeat-x !important;
    }

    .info-box-concept i.fa.fa-times {
        cursor: pointer;
        color: white;
    }

    .small-box .info-box-text {
        font-size: 1.1em;
        color: white;
    }

    .totals-by-status {
        font-size: 0.8rem;
    }

    .muted {
        color: rgba(0, 0, 0, 0.5);
    }
</style>
